import angular from 'angular'
import * as Sentry from '@sentry/browser'

class RavenService {
  setUserContext (user = {}) {
    Sentry.setUser(user)
  }
}

export default angular.module('raven.service', [
])
  .service('RavenService', RavenService).name
